(function($) {

    toastr.options.positionClass = "toast-top-full-width";
    toastr.options.showMethod = "slideDown";
    toastr.options.hideMethod = "slideUp";
    toastr.options.preventDuplicates = true;


    var EnquiryList = function() {

        var readCookie = function() {
            return Cookies.getJSON('enquiryList') || [];
        }

        var writeCookie = function(data) {
            Cookies.set('enquiryList', data);
        }

        var findIndexById = function(list, id) {
            return list.map(function(item) { return item.id }).indexOf(id);
        }

        this.addToList = function(id, quantity) {
            var list = readCookie();
            if(findIndexById(list, id) === -1) {
              list.push({id: id, qty: quantity});
            }

            writeCookie(list);
        }

        this.removeFromList = function(id) {
            var list = readCookie();
            var index = findIndexById(list, id);
            if(index !== -1) {
                list.splice(index, 1);
            }

            writeCookie(list);
        }

        this.setQuantity = function(id, quantity) {
            this.addToList(id, quantity);

            var list = readCookie();
            var index = findIndexById(list, id);

            list[index].qty = quantity;
            writeCookie(list);
        }

        this.length = function() {
            return readCookie().length;
        }

        this.clearList = function() {
            writeCookie([]);
        }

    };

    var EnquiryDialog = function() {
        var $dialog = $('#enquiry-dialog');
        var launchSelector = '[data-product-enquiry]';

        this.launch = function() {
            $('body').removeClass('pushy-open-right');
            $dialog
                .find('.filler').html("").end()
                .find('.dialog__title span').html("").end()
                .find('input.js-product-sku').val("").end()
                .find('input.js-product-name').val("").end()
            ;

            clearForm();
            $.fancybox.open({
                src: '#enquiry-dialog',
                type: 'inline',
                beforeClose: this.controller.refreshMenuBadge,
            });

            if(this.controller.list.length() == 0) {
                $dialog.find('.products .products__list').html("You don't have any products in your enquiry yet. Browse the site and click the 'Add to Enquiry' button next to products to add them to your enquiry.");
            } else {
                $dialog.find('.products .products__list').html('Loading products...')
                loadProducts().then(function(data) {
                    $dialog.find('.products .products__list').html(data.html)
                });
            }


        }.bind(this);

        var loadProducts = function() {
            return $.when(
                $.getJSON(mesh_wp_config.wp_admin_ajax, {action: 'enquiry_list'})
            );
        }

        var clearForm = function() {
          $dialog
            .find('.has-error').removeClass('has-error').end()
            .find('.success-message').detach().end()
            .find('.error-message').detach().end()
            .find('button[type=submit]').prop('disabled', false).end()
            .find('form').trigger('reset').end()
            .find('.products .products__list').html('Loading products...')
          ;


        }

        clearForm = clearForm.bind(this);

        var handleQuantityUpdate = function(event) {
          var productId = $(event.target).data('productId');
          this.controller.list.setQuantity(productId, $(event.target).val())
        };

        handleQuantityUpdate = handleQuantityUpdate.bind(this);

        var handleRemoval = function(event) {
            var productId = $(event.target).data('productId');
            this.controller.list.removeFromList(productId);
            $(event.target).closest('.productv').fadeOut(function() { $(this).detach(); });
            this.controller.refreshMenuBadge();
        };

        handleRemoval = handleRemoval.bind(this);



        var registerHooks = function() {
            $dialog.on('keyup', '[name=quantity]', handleQuantityUpdate);
            $dialog.on('click', '[data-action=remove]', handleRemoval);
            $dialog.on('click', '.success-message', function() { $.fancybox.close(); clearForm(); } )
            //$dialog.on('change', '[data-nature-of-business]', handleNatureOfBusinessChange);
        }

        registerHooks();
    }

    EnquiryController = function(dialog, list) {
        dialog.controller = this;
        list.controller = this;

        this.dialog = dialog;
        this.list = list;

        var self = this;

        var registerHooks = function() {
            $('[data-launch-product-enquiry], .product-enquiry-menu-item a').on('click', function(event) {
                event.preventDefault();
                dialog.launch();
            });
            $('[data-product-enquiry]').on('click', function() {
                list.addToList($(this).data('productId'));
                self.refreshMenuBadge();
                toastr.success("Product added to your enquiry list. Continue adding products, or <a href='javascript:;' data-launch-product-enquiry='true'>send an enquiry now</a>.");
            });

            toastr.options.onclick = function() {
                toastr.clear();
                dialog.launch();
            }
        }

        this.refreshMenuBadge = function() {
            $menuItem = $('.product-enquiry-menu-item a');
            $menuItem.each(function() {
                var $span = $(this).find('span');
                if($span.length == 0) {
                    $span = $('<span/>');
                    $(this).append($span);
                }

                if(list.length() == 0) {
                  $span.detach();
                  $('body').toggleClass('has-products-in-enquiry', false);
                } else {
                  $('body').toggleClass('has-products-in-enquiry', true);
                  $span.text(list.length());
                }
            });
        }

        registerHooks();
        this.refreshMenuBadge();
    }

    $(function() {
      window.enquiryController = new EnquiryController(
        new EnquiryDialog,
        new EnquiryList
      );
    });



    $('.productv__details').on('click', function(event) {
        if(Modernizr.mq('(max-width: 767px)')) {
            $(this).closest('.productv').toggleClass('productv--mobile-expanded');
            $(this).closest('.productv').find('.productv__mobile-details').slideToggle();
        }
    });
})(jQuery);